import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";

const Menu = ({ menuClass, textEnter, textLeave }) => {
  const [currentPath, setCurrentPath] = useState("");
  const location = useLocation();
  useEffect(() => {
    setCurrentPath(location.hash);
  }, [currentPath, location]);

  // useEffect(() => {
  //   window.addEventListener("scroll", (e) => {
  //     if (window.scrollY <= 600) {
  //       navigate("#home");
  //     } else if (window.scrollY <= 1200) {
  //       navigate("#about");
  //     } else if (window.scrollY <= 2451) {
  //       navigate("#portfolio");
  //     } else if (window.scrollY <= 2421) {
  //       navigate("#resume");
  //     } else if (window.scrollY <= 3142) {
  //       navigate("#services");
  //     } else if (window.scrollY <= 4518) {
  //       navigate("#contact");
  //     }
  //     console.log(window.scrollY);
  //   });
  // }, []);

  return (
    <ul className={`${menuClass} `}>
      <li>
        <a
          onMouseOver={textEnter}
          onMouseOut={textLeave}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          className={
            currentPath === "#home" || currentPath === ""
              ? " bg-own-gray-black px-4 py-1 rounded-lg transition-all delay-150 ease-out"
              : "  px-4 py-1 rounded-lg transition-all delay-150 ease-out"
          }
          href="#home"
        >
          Home
        </a>
      </li>
      <li>
        <a
          onMouseOver={textEnter}
          onMouseOut={textLeave}
          className={
            currentPath === "#about"
              ? " bg-own-gray-black px-4 py-1 rounded-lg transition-all delay-150 ease-out"
              : "  px-4 py-1 rounded-lg transition-all delay-150 ease-out"
          }
          href="#about"
        >
          About
        </a>
      </li>
      <li>
        <a
          onMouseOver={textEnter}
          onMouseOut={textLeave}
          className={
            currentPath === "#portfolio"
              ? " bg-own-gray-black px-4 py-1 rounded-lg transition-all delay-150 ease-out"
              : "  px-4 py-1 rounded-lg transition-all delay-150 ease-out"
          }
          href="#portfolio"
        >
          Portfolio
        </a>
      </li>
      <li>
        <a
          onMouseOver={textEnter}
          onMouseOut={textLeave}
          className={
            currentPath === "#resume"
              ? " bg-own-gray-black px-4 py-1 rounded-lg transition-all delay-150 ease-out"
              : "  px-4 py-1 rounded-lg transition-all delay-150 ease-out"
          }
          href="#resume"
        >
          Resume
        </a>
      </li>
      <li>
        <a
          onMouseOver={textEnter}
          onMouseOut={textLeave}
          className={
            currentPath === "#services"
              ? " bg-own-gray-black px-4 py-1 rounded-lg transition-all delay-150 ease-out"
              : "  px-4 py-1 rounded-lg transition-all delay-150 ease-out"
          }
          href="#services"
        >
          Services
        </a>
      </li>
      {/* <li><a  href="#blog">Blog</a></li> */}
      <li>
        <a
          onMouseOver={textEnter}
          onMouseOut={textLeave}
          className={
            currentPath === "#blog"
              ? " bg-own-gray-black px-4 py-1 rounded-lg transition-all delay-150 ease-out"
              : "  px-4 py-1 rounded-lg transition-all delay-150 ease-out"
          }
          href="#blog"
        >
          Blog
        </a>
      </li>
      <li>
        <a
          onMouseOver={textEnter}
          onMouseOut={textLeave}
          className={
            currentPath === "#contact"
              ? " bg-own-gray-black px-4 py-1 rounded-lg transition-all delay-150 ease-out"
              : "  px-4 py-1 rounded-lg transition-all delay-150 ease-out"
          }
          href="#contact"
        >
          Contact
        </a>
      </li>
    </ul>
  );
};

export default Menu;
